import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "./Question5.css";
import Question from "./images/question.gif";
import Excited from "./images/excited.gif";
import Overwhelmed from "./images/overwhelmed.gif";
import Confused from "./images/confused.gif";
import Skeptical from "./images/skeptical.gif";

const Question5 = ({ onAnswer, userResponse }) => {
  const [selectedImage, setSelectedImage] = useState(Question);

  const question = {
    title:
      "How would you feel if you could start writing your thesis, review paper, and proposal simultaneously, with AI assisting you in every step?", // The title of the question
    questionImage: Question,
    options: [
      { label: "Excited", image: Excited },
      { label: "Overwhelmed", image: Overwhelmed },
      { label: "Confused", image: Confused },
      { label: "Skeptical", image: Skeptical },
    ],
  };

  const handleOptionChange = (title, label, image) => {
    onAnswer(title, label);
    setSelectedImage(image);
  };

  const handleNext = () => {
    if (!userResponse[question.title]) {
      return;
    }

    setTimeout(() => {
      onAnswer(question.title, null);
    }, 1000);
  };

  return (
    <AnimatePresence>
      <motion.div
        className="question5-container"
        initial={{ opacity: 0, x: "10%" }}
        animate={{ opacity: 1, x: 0 }}
        exit={{ opacity: 0, x: "-100vw" }}
        transition={{ duration: 1 }}
      >
        <motion.div
          className="image-container"
          initial={{ opacity: 0, x: "-10%" }}
          animate={{ opacity: 1, x: 0 }}
          exit={{ opacity: 0, x: "-100vw" }}
          transition={{ duration: 0.5, ease: "easeOut" }}
        >
          <motion.img
            key={selectedImage}
            className="question5-img"
            src={selectedImage}
            alt="Selected Option"
            initial={{ opacity: 0, x: "-50vw" }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 1, ease: "easeOut" }}
          />
        </motion.div>

        <motion.h2
          className="question5-head"
          initial={{ opacity: 0, x: "10%" }}
          animate={{ opacity: 1, x: 0 }}
          exit={{ opacity: 0, x: "-100vw" }}
          transition={{ duration: 0.5, delay: 0.3 }}
        >
          {question.title}
        </motion.h2>

        <div className="option5-container">
          {question.options.map((option, index) => (
            <motion.label
              key={index}
              className={`radio5-option ${
                userResponse[question.title] === option.label ? "checked" : ""
              }`}
              htmlFor={`option-${index}`}
              initial={{ opacity: 0, x: "10%" }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: "-100vw" }}
              transition={{
                duration: 0.5,
                delay: 0.5 + index * 0.2,
              }}
            >
              <input
                type="radio"
                id={`option-${index}`}
                name={`question-${question.title}`}
                value={option.label}
                checked={userResponse[question.title] === option.label}
                onChange={() =>
                  handleOptionChange(question.title, option.label, option.image)
                }
              />
              <span className="radio5-label">{option.label}</span>
            </motion.label>
          ))}
        </div>

        <motion.button
          type="submit"
          initial={{ opacity: 0, x: "10%" }}
          animate={{ opacity: 1, x: 0 }}
          exit={{ opacity: 0, x: "-100vw" }}
          transition={{ duration: 0.5, delay: 1 }}
          onClick={handleNext}
          disabled={!userResponse[question.title]}
        >
          Next Question
        </motion.button>
      </motion.div>
    </AnimatePresence>
  );
};

export default Question5;
